export const NOT_SET = 'not_set'

export const VENDOR = {
  GTM: 'gtm',
}
